import { Context as TContext, createContext, Dispatch, FC, ReactNode, SetStateAction, useContext, useState } from "react";

import { IEnv, AppStateType, IAuthData, IAuthTokenData } from 'types/index'

type TProps = {
  children: ReactNode
}

type TFunctionType = () => AppStateType

const Context: TContext<AppStateType> = createContext<AppStateType> ({
  state: '',
  setState: () => null,
  env: {
    isOperational: false,
    hasGlobalMenu: false,
    hasGlobalTopbar: false
  },
  auth: {} as IAuthData,
  setAuth: () => null,
  authToken: {} as IAuthTokenData,
  setAuthToken: () => null
});

const useApp: TFunctionType = () => useContext<AppStateType> (Context);

const AppState: TFunctionType = () => {
  const [state, setState]: [string, Dispatch<SetStateAction<string>>] = useState<string> ("initial state!");
  const [env]: [IEnv, Dispatch<SetStateAction<IEnv>>] = useState<IEnv> ({
    isOperational: process.env.REACT_APP_ISOPERATIONAL === "true",
    hasGlobalMenu: process.env.REACT_APP_HASGLOBALMENU === "true",
    hasGlobalTopbar: process.env.REACT_APP_HASGLOBALTOPBAR === "true",
  });
  const [auth, setAuth]: [IAuthData, Dispatch<SetStateAction<IAuthData>>] = useState<IAuthData>({} as IAuthData);
  const [authToken, setAuthToken]: [IAuthTokenData, Dispatch<SetStateAction<IAuthTokenData>>] = useState<IAuthTokenData>({} as IAuthTokenData);
  const appState: AppStateType = { state, setState, env, auth, setAuth, setAuthToken, authToken }

  return appState;
};

const AppContext: FC<TProps> = ({ children }: TProps): JSX.Element => (
  <Context.Provider value={AppState ()}>{children}</Context.Provider>
);

export { AppContext, useApp };
